import Vue from 'vue'
import Router from 'vue-router'
import Layout from '../views/layout'
const defaultLayout = {render(){return (<router-view />)}}

Vue.use(Router)
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/home',
      hidden: true
    },
    {
      path: '/home',
      component: Layout,
      meta: {
        title: '首页',
        icon: 'home'
      },
      children: [
      {
        path: '',
        name: 'Home',
        component: () => import('@/views/home')
      }]
    },
    {
      path: '/order',
      alwaysShow: true,
      component: Layout,
      meta: {
        icon: 'order',
        title: '订单管理',
      },
      children: [
        {
          path: 'bill',
          name: 'Order_Bill',
          component: () => import('@/views/order/bill'),
          meta: {
            title: '账单管理',
            auth: 'Order_Bill'
          }
        },
        {
          path: 'invoice',
          name: 'Order_Invoice',
          component: () => import('@/views/order/invoice/index.vue'),
          meta: {
            title: '开票管理',
            auth: 'Order_Invoice'
          }
        }
      ]
    },
    {
      path: '/finance',
      component: Layout,
      alwaysShow: true,
      meta: {
        icon: 'finance',
        title: '财务审核',
      },
      children: [
      {
        path: 'review',
        name: 'Finance_Order_Review',
        component: () => import('@/views/finance/order/review'),
        meta: {
          title: '待审核',
          auth: 'Finance_Order_Review'
        }
      },
      {
        path: 'approved',
        name: 'Finance_Order_Approved',
        component: () => import('@/views/finance/order/approved'),
        meta: {
          title: '已审核',
          auth: 'Finance_Order_Approved'
        }
      },
      {
        path: 'bill',
        name: 'Finance_Bill',
        component: () => import('@/views/finance/bill'),
        meta: {
          title: '账单管理',
          auth: 'Finance_Bill',
        }
      },
      {
        path: 'order',
        component: defaultLayout,
        meta: {
          title: '订单审核',
        },
        children: [{
          path: 'review',
          name: 'Finance_Review',
          component: () => import('@/views/finance/review'),
          meta: {
            title: '待审核',
            auth: 'Finance_Review'
          }
        },
        {
          path: 'approved',
          name: 'Finance_Approved',
          component: () => import('@/views/finance/approved'),
          meta: {
            title: '已审核',
            auth: 'Finance_Approved'
          }
        }]
      },
      {
        path: 'invoice',
        name: 'Finance_Invoice',
        component: () => import('@/views/order/invoice/index.vue'),
        meta: {
          title: '开票管理',
          auth: 'Finance_Invoice'
        }
      }]
    },
    {
      path: '/tax',
      component: Layout,
      alwaysShow: true,
      meta: {
        icon: 'tax',
        title: '税务中心',
      },
      children: [
        {
          path: 'archive',
          name: 'Tax_Archive',
          component: () => import('@/views/tax/archive'),
          meta: {
            title: '税务档案',
            auth: 'Tax_Archive'
          }
        },
        {
          path: 'declare',
          alwaysShow: true,
          component: defaultLayout,
          meta: {
            title: '申报管理',
          },
          children: [
            {
              path: 'follow',
              name: 'Tax_Declare_Follow',
              component: () => import('@/views/tax/declare/follow'),
              meta: {
                title: '申报跟进',
                auth: 'Tax_Declare_Follow'
              }
            }
          ]
        }
      ]
    },
    {
      path: '/evidence',
      alwaysShow: true,
      component: Layout,
      meta: {
        icon: 'db',
        title: '使用证据',
      },
      children: [
      {
        path: 'engrave',
        name: 'Evidence_Engrave',
        component: () => import('@/views/evidence/engrave'),
        meta: {
          title: '打标管理',
          auth: 'Evidence_Engrave'
        }
      }]
    },
    {
      path: '/tool',
      component: Layout,
      alwaysShow: true,
      meta: {
        icon: 'tool',
        title: '智能工具',
      },
      children: [
      {
        path: 'item_confirm',
        name: 'Tool_ItemConfirm',
        component: () => import('@/views/tool/item_confirm/index'),
        meta: {
          title: '小项确认工具',
          auth: 'Tool_ItemConfirm'
        }
      },
      {
        path: 'item_hot',
        name: 'Tool_ItemHot',
        component: () => import('@/views/tool/item_hot'),
        meta: {
          title: '热门小项',
          auth: 'Tool_ItemHot'
        }
      },
      {
        path: 'monitor',
        name: 'Tool_Monitor',
        component: () => import('@/views/tool/monitor'),
        meta: {
          title: '商标监测',
          auth: 'Tool_Monitor'
        }
      },
      {
        path: 'trademark',
        component: defaultLayout,
        meta: {
          title: '商标检索'
        },
        children: [
        {
          path: 'search',
          name: 'Tool_Trademark_Search',
          component: () => import('@/views/tool/trademark/search'),
          meta: {
            title: '检索商标',
            auth: 'Tool_Trademark_Search'
          }
        }]
      }]
    },
    {
      path: '/login',
      component: () => import('@/views/login/index'),
      hidden: true
    },
    {
      path: '/icons',
      component: () => import('@/views/lab/icons'),
      hidden: true
    },
    {
      path: '*',
      redirect: '/',
      hidden: true
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js